import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useLayoutStore } from '@/features/layout/store';
import { isLocalHost, isMercurioSandbox } from '@/std/url';

// Interval to check for new versions (10 minutes)
const versionCheckInterval = 1000 * 60 * 10;

async function fetchRemoteVersion(url: string, signal: AbortSignal): Promise<string> {
    const response = await fetch(url, { cache: 'no-store', signal });
    const json = await response.json();
    return json.version;
}

export function useAppVersion() {
    // Os sandboxes dos sistemas whitelabel só atualizam quando é feito o deploy em produção
    const versionUrl = isMercurioSandbox()
        ? 'https://s3.sa-east-1.amazonaws.com/sandbox.app.mercurioapp.com.br/version.json'
        : 'https://s3.sa-east-1.amazonaws.com/app.mercurioapp.com.br/version.json';

    const {
        data: versionData,
        error: versionError,
        isFetched: versionFetched,
    } = useQuery({
        enabled: !isLocalHost(),
        queryFn: ({ signal }) => fetchRemoteVersion(versionUrl, signal),
        queryKey: ['remoteVersion', versionUrl],
        refetchInterval: versionCheckInterval,
        refetchIntervalInBackground: true,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
        retry: false,
    });

    useEffect(() => {
        if (versionFetched) {
            if (versionError) {
                console.error('Error fetching remote version:', versionError);
            }

            useLayoutStore.setState({ newVersion: versionError ? null : (versionData ?? null) });
        }
    }, [versionData, versionError, versionFetched]);
}
